module.exports = {"TXTWCL_24_hour_lockout":{"id":"TXTWCL_24_hour_lockout","defaultMessage":"Мгновенный 24-часовой перерыв"}}